<template>
  <react-wrapper :component="PlanningAlerts" />
</template>

<script>
import ReactWrapper from "view/wrappers/react-wrapper";

import { PlanningAlerts } from "react-migration/domains/dashboard/planningAlerts/PlanningAlerts";

export default {
  components: {
    ReactWrapper,
  },
  computed: {
    PlanningAlerts() {
      return PlanningAlerts;
    },
  },
};
</script>
